<script>
  import { SidebarItem } from 'flowbite-svelte';

  export let href = null;
  export let label;
  export let active;
  export let icon;
  export let badge = null;
</script>

<SidebarItem
  {href}
  {label}
  {active}
  activeClass="flex items-center p-2 text-base font-normal text-blue-500 rounded-lg hover:bg-primary-100"
  nonActiveClass="flex items-center p-2 text-base font-normal text-gray-500 rounded-lg hover:bg-primary-100"
>
  <svelte:fragment slot="icon">
    <svelte:component this={icon} class="mr-2 h-5 w-5" />
  </svelte:fragment>
  <svelte:fragment slot="subtext">
    {#if badge}
      <span
        class="ms-3 inline-flex items-center justify-center rounded-full bg-gray-200 px-2 text-sm font-medium text-gray-800 dark:bg-gray-700 dark:text-gray-300"
      >
        {badge}
      </span>
    {/if}
  </svelte:fragment>
</SidebarItem>
